import axios, { AxiosError } from 'axios'
import { useSnackbar } from 'notistack'
import type React from 'react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
	children: React.ReactElement
}

const AxiosErrorsHandler = ({ children }: IProps) => {
	const { enqueueSnackbar } = useSnackbar()
	const { t } = useTranslation()

	useEffect(() => {
		const interceptor = axios.interceptors.response.use(
			response => response,
			error => {
				if (error && error instanceof AxiosError) {
					if (
						(error.config as Record<string, unknown> | undefined)
							?.suppressGlobalToast
					) {
						return Promise.reject(error)
					}
					if (error.code === 'ERR_NETWORK') {
						enqueueSnackbar(t('toast.error.connectivity'), {
							variant: 'error',
						})
					} else if (error.code === 'ERR_BAD_RESPONSE') {
						enqueueSnackbar(t('toast.error.server'), {
							variant: 'error',
						})
					}
				}
				return Promise.reject(error)
			}
		)
		return () => axios.interceptors.response.eject(interceptor)
	}, [enqueueSnackbar, t])
	return children
}

export default AxiosErrorsHandler
